export function convertParamsToQueryString<Params>(params: Params): string {
  const searchParams = new URLSearchParams();

  if (params && typeof params === "object") {
    for (const [key, value] of Object.entries(params)) {
      if (paramsValueIsValidType(value)) {
        if (Array.isArray(value)) {
          value.forEach((arrayItem: string | number | boolean) =>
            searchParams.append(`${key}[]`, String(arrayItem))
          );
        } else {
          searchParams.append(key, String(value));
        }
      } else {
        console.error(
          `convertParamsToQueryString: Received "${key}: ${String(value)}". ` +
            "Values must be one of (or an array containing) the following types: string, number, boolean."
        );
        continue;
      }
    }
  }

  return searchParams.toString();
}

const allowedTypes = ["string", "number", "boolean"];

function paramsValueIsValidType(paramsValue: unknown): boolean {
  return (
    allowedTypes.includes(typeof paramsValue) ||
    (Array.isArray(paramsValue) &&
      paramsValue.every((param: unknown[]) =>
        allowedTypes.includes(typeof param)
      ))
  );
}
